export default __webpack_public_path__ + "static/media/fedora.bced955f.png";